import React from 'react';

const Libraries: React.FC = (): JSX.Element => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div>
            <p>Coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Libraries;
